import axios from 'axios'

export const getStoresByRegion = async region => {
  const response = await axios
    .get(`/api/v3/regions/${region}/stores`)
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}
